import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vmodal from 'vue-js-modal'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import VueCookies from 'vue-cookies'
import vSelect from 'vue-select'
import VueRouter from 'vue-router'


Vue.config.productionTip = false
Vue.use(vmodal, { componentName: 'vmodal', dynamic: true, injectModalsContainer: true })
Vue.use(VueMoment, { componentName: 'moment', dynamic: true, injectModalsContainer: true })
// Vue.use(BootstrapVue)
Vue.use(VueCookies)
Vue.component('v-select', vSelect)
Vue.use(VueRouter)
// register globally

new Vue({
  router,
  store,
  vmodal,
  // BootstrapVue,
  VueCookies,
  render: h => h(App)
}).$mount('#app')
